
define('text!views/common/information.html',[],function () { return '<div class="panel panel-default" data-bind="visible: message !=\'\'"><div class="panel-body information"><div class="icon"><img src="img/icons/info-circle-svgrepo-com.svg"></div><div class="message" data-bind="html: message"></div></div></div>';});

